import { Injectable } from '@angular/core'
import { HttpErrorResponse } from '@angular/common/http'
import { NzNotificationService } from 'ng-zorro-antd/notification'

@Injectable({
  providedIn: 'root',
})
export class HttpResponseHandlerService {

  constructor(private notification: NzNotificationService) {}

  public notifySuccess(title: string, content: string): void {
    this.notification.success(title, content)
  }

  public notifyInfo(title: string, content: string): void {
    this.notification.info(title, content)
  }

  public notifyWarning(title: string, content: string): void {
    this.notification.warning(title, content)
  }

  public notifyError(error: HttpErrorResponse): void {
    const statusCode: number = error.status
    let message: string = 'Server error occurred.'
    let title: string = 'Error'

    if (statusCode === 0) {
      message = 'Could not connect to the server.'
    } else {
      if (error.error && error.error.error) {
        message = error.error.error
      } else if (error.message) {
        message = error.message
      }
      title = `Error ${statusCode}!`
    }

    this.notification.error(title, message)
  }

  public getNotificationInstance(): NzNotificationService {
    return this.notification
  }
}
